module.exports = __webpack_public_path__ + "img/contract-status-2.a39155b1.png";